<template>
    <div class="view view--email-verification">
        <email-verification />
    </div>
</template>

<script>
    import emailVerification from '../../components/EmailVerification.vue';

    export default {
        components: {
            emailVerification
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/EmailVerification.vue